var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AppBar, Toolbar } from '@mui/material';
export var variants = [
    'standard-main',
    'filled-main',
    'standard-variant',
    'filled-variant',
];
export var configurations = [
    'small-centered',
    'small',
    'medium',
    'large',
];
var variantSx = {
    'standard-main': {
        backgroundColor: 'background.paper',
        color: 'surface.onColor',
        boxShadow: 'unset',
    },
    'filled-main': {
        backgroundColor: 'surfaceVariant.main',
        color: 'surfaceVariant.onColor',
        boxShadow: 'unset',
    },
    'standard-variant': {},
    'filled-variant': {},
};
export default function PFHeader(_a) {
    var _b = _a.pfVariant, pfVariant = _b === void 0 ? 'standard-main' : _b, sx = _a.sx, children = _a.children, props = __rest(_a, ["pfVariant", "sx", "children"]);
    return (_jsx(AppBar, __assign({ position: "static", sx: __assign(__assign({}, variantSx[pfVariant]), sx) }, props, { children: _jsx(Toolbar, __assign({ sx: {
                pt: 1,
                pb: 1,
                pl: 3,
                pr: 3,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            } }, { children: children })) })));
}
